// src/components/headercustom.tsx
import React from "react";
import { Button } from "@/components/ui/button";
import { SidebarTrigger } from "./sidebar";
import { User, LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import logo from "@/assets/favicon_white.png";

interface HeaderCustomProps {
  user?: {
    name?: string;
  };
  handleLogout: () => void;
}

const HeaderCustom: React.FC<HeaderCustomProps> = ({ user, handleLogout }) => {
  return (
    <header className="bg-gradient-to-r from-green-600 to-green-700 text-white shadow-md">
      <div className="mx-auto max-w-7xl px-3 py-3 sm:px-6 sm:py-4">
        <div className="flex items-center justify-between gap-2">

          {/* Left: Sidebar trigger */}
          <div className="flex items-center">
            <SidebarTrigger className="text-white hover:bg-white/20" />
          </div>
          {/* Center: Title (hide on small screens) */}
          <div>
            <Link
              to="/landing"
              className="hidden sm:flex items-center gap-2 text-lg sm:text-2xl font-bold tracking-tight transition-colors duration-200 hover:text-gray-200 "
            >
              <img
                src={logo}
                alt="Court Replay Logo"
                className="w-6 h-6 sm:w-7 sm:h-7 object-contain"
              />
              <span>Court Replay</span>
            </Link>
          </div>

          {/* Right: User & Logout */}
          <div className="flex items-center gap-2 sm:gap-4">
            <Link
              to="/profile"
              className="flex items-center gap-2 rounded-md px-2 py-1 hover:bg-white/20"
            >
              <User className="h-5 w-5" />
              {/* Hide username on very small screens */}
              <span className="hidden sm:inline text-sm">
                {user?.name ?? "Guest"}
              </span>
            </Link>

            <Button
              variant="ghost"
              size="icon"
              onClick={handleLogout}
              className="text-white hover:bg-white/20"
            >
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderCustom;